// removed by extract-text-webpack-plugin
module.exports = {"modal":"_2Qjzk","container":"_2Ff8F","verticalSeparator":"_2SC6B","horizontalSeparator":"_34wZ5"};


//////////////////
// WEBPACK FOOTER
// ./app/components/demote-moderator-modal/demote-moderator-modal.scss
// module id = 912
// module chunks = 3 4 5 6 7